module.exports = __webpack_public_path__ + "static/media/snow.7368bad8.svg";